export default __webpack_public_path__ + "static/media/goopter-flashbot-modular-compartments.d7c9cd51.jpg";